import { css, cx } from '@emotion/css';
import { Row, Col, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { doGetAccountBalance, doGetCumulativeOrderList, doGetPositionList, getTransfers } from 'src/actions';
import { FilterBarConstant } from 'src/constants';
import { useBalanceSummary, useIsMobile, useSubmittedAccountSelector } from 'src/hooks';
import { MCard } from 'src/lib';
import { OrderStatusLabel } from 'src/models';
import { Display, FlexDirection, ScreenBreakpoint, Spacing } from 'src/styles';
import { mapFilterToGetOrderListQueryParamsDto } from 'src/utils';

import { BalanceSummary } from './BalanceSummary';
import { BalanceSummaryChart } from './BalanceSummaryChart';

const cardStyle = css`
  ${Spacing.p24}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.p4};
  }
`;

export const AccountSummary = () => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const { account } = useSubmittedAccountSelector();
  const {
    cashAvailable,
    pendingTransfersTotal,
    accountValue,
    tradedPositionsTotal,
    nonTradedPositionsTotal,
    workingOrdersTotal,
    pendingOfferOrdersTotal,
  } = useBalanceSummary();

  const onRefresh = () => {
    dispatch(doGetAccountBalance(account.accountId));
    dispatch(doGetPositionList({ params: { accountId: account.accountId } }));
    dispatch(
      doGetCumulativeOrderList({
        params: {
          accountId: account.accountId,
        },
        queryParams: mapFilterToGetOrderListQueryParamsDto({
          filterBy: [`${OrderStatusLabel.WORKING}_${FilterBarConstant.StatusCategory.Order}`],
          timeline: FilterBarConstant.FixedTimeline.ThisYear,
        }),
      }),
    );
    dispatch(getTransfers(account.accountId));
  };

  return (
    <Row justify='center'>
      <Col span={24}>
        <MCard className={cardStyle}>
          <Row>
            <Col
              span={24}
              className={cx(Display.flex, isMobile ? FlexDirection.column : FlexDirection.row, Spacing.p24)}>
              <Space.Compact direction={isMobile ? 'vertical' : 'horizontal'} block>
                <BalanceSummaryChart
                  summary={{
                    cashAvailable,
                    pendingTransfersTotal,
                    accountValue,
                    tradedPositionsTotal,
                    nonTradedPositionsTotal,
                    workingOrdersTotal,
                    pendingOfferOrdersTotal,
                  }}
                />
                <BalanceSummary
                  summary={{
                    cashAvailable,
                    pendingTransfersTotal,
                    tradedPositionsTotal,
                    nonTradedPositionsTotal,
                    workingOrdersTotal,
                    pendingOfferOrdersTotal,
                  }}
                  onRefresh={onRefresh}
                />
              </Space.Compact>
            </Col>
          </Row>
        </MCard>
      </Col>
    </Row>
  );
};
